// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TAutomatedEmailDashboardApiResponse,
  TAutomatedEmailSaleType,
  TDashboardStats,
  TAutomatedEmailDomainStatus,
} from '~/modules/opportunities/automated-email/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

export class AutomatedEmailDomainModel extends DefaultResource {
  protected endpoint: string = 'automated-email/';

  getStatus(
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TAutomatedEmailDomainStatus> {
    return this.get<TAutomatedEmailDomainStatus>('domains/status', undefined, requestConfig);
  }

  getDashboard(
    period: number,
    patchId: number,
    saleType: TAutomatedEmailSaleType,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TDashboardStats> {
    return this
      .get<TAutomatedEmailDashboardApiResponse>(
        'dashboard',
        { period, patch_id: patchId, sale_type: saleType },
        requestConfig
      )
      .then((row: TAutomatedEmailDashboardApiResponse) =>
        this.mapAutomatedEmailDashboardApiResponse(row)
      );
  }

  private mapAutomatedEmailDashboardApiResponse(
    row: TAutomatedEmailDashboardApiResponse
  ): TDashboardStats {
    return {
      contacts_monitored: row.contacts_monitored,
      emails_sent: row.emails_sent,
      outbox_pending: row.outbox_pending,
      is_automated: row.is_fully_automated,
    };
  }
}
